import {
  getUfcShopComposedApi as api,
  i18nFormat,
} from '@unionfab/ufc-shop-commons';
import * as S from '@unionfab/ufc-shop-commons';
import { Spin } from 'antd';
import cn from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';

import { useInquiryMaterialStore } from '@/stores';

export const OrderTotalPrice = ({
  order,
  className,
}: {
  order: S.ShopOrder;
  className?: string;
}) => {
  const { code, status, price, id } = order;
  const [newPriceInfo, setNewPriceInfo] = useState({} as S.ShopOrderPrice);
  const { materials } = useInquiryMaterialStore();
  const expandedSkus = useMemo(
    () =>
      S.findExpandedSku(
        order.items.map(item => ({
          materialId: item?.materialSkuVO?.materialId,
          skuId: item?.skuId,
        })),
        materials || [],
      ),
    [order.items, materials],
  );

  const isUnpaid = S.UnpaidInquiryOrderStatusList.includes(status);

  const { data: priceInfo, isLoading } = useQuery({
    refetchOnWindowFocus: false,
    enabled: isUnpaid && !!order,
    queryKey: ['priceInfo', order],
    refetchInterval: q => (q && q.hasComputingItem ? 3000 : false),
    queryFn: () => {
      const expressId = S.get(
        order,
        o => o.requirements.customerSelections.delivery.expressId,
      );

      return api().shopOrderQueryApi.calcPrice(code, { expressId });
    },
  });

  useEffect(() => {
    if (expandedSkus.length > 0 && isUnpaid) {
      const expressId = S.get(
        order,
        o => o.requirements.customerSelections.delivery.expressId,
      );
      const skuMapping = expandedSkus.reduce((acc, cur) => {
        acc[cur.oldSkuId] = cur.newSkuId;
        return acc;
      }, {} as Record<string, string>);
      api()
        .shopOrderQueryApi.calcPriceBySku(code, [
          {
            skuMapping,
            orderId: id,
            expressId,
          },
        ])
        .then(res => {
          setNewPriceInfo(res);
        });
    }
  }, [expandedSkus, isUnpaid]);

  const totalPrice = useMemo(() => {
    if (!isUnpaid) return S.get(price, p => p.total);

    let showPrice = priceInfo;
    if (expandedSkus.length > 0) {
      showPrice = newPriceInfo;
    }

    // if (expandedSkus.length > 0) return '需要重新';

    if ((showPrice && showPrice.hasComputingItem) || isLoading) return <Spin />;

    if (status == 'WAIT_SUBMIT') return S.get(showPrice, p => p.subTotal);

    const pricePreStr =
      order.inQuotation && S.get(showPrice, p => p.total) !== 'RFQ'
        ? 'Estimated '
        : '';

    return S.get(showPrice, p => pricePreStr + p.total);
  }, [priceInfo, price, isLoading, isUnpaid, expandedSkus, newPriceInfo]);

  // const quotationUpdateStr = useMemo(() => {
  //   if (
  //     priceInfo &&
  //     !priceInfo.customerCheckedAt &&
  //     order.status == 'WAIT_CUSTOM_CONFIRM'
  //   ) {
  //     return (
  //       <div style={{ color: '#ff4d4f', marginTop: 4 }}>
  //         !{i18nFormat('updated')}
  //       </div>
  //     );
  //   }

  //   return <></>;
  // }, [priceInfo, order]);

  return (
    <span className={cn(className)}>
      {totalPrice}
      {/* 注释报价待确认提示 */}
      {/* {quotationUpdateStr} */}
    </span>
  );
};
